import type { IconType } from 'react-icons';
import {
  PiStar,
  PiUser,
  PiUsersThree,
  PiPackage,
  PiBookmarkSimple,
  PiClipboard,
  PiPencilSimpleLine,
  PiFileText,
  PiTruck,
  PiWrench,
  PiLightning,
  PiWarning,
  PiDrop,
  PiGlobe,
  PiHouse,
  PiTrash,
} from 'react-icons/pi';

// Shown in place of a group icon whose image fails to load, picked by the
// icon's position so each option still looks distinct.
export const FALLBACK_GROUP_ICONS: IconType[] = [
  PiStar,
  PiUser,
  PiUsersThree,
  PiPackage,
  PiBookmarkSimple,
  PiClipboard,
  PiPencilSimpleLine,
  PiFileText,
  PiTruck,
  PiWrench,
  PiLightning,
  PiWarning,
  PiDrop,
  PiGlobe,
  PiHouse,
  PiTrash,
];

export const fallbackIconAt = (index: number) => FALLBACK_GROUP_ICONS[index % FALLBACK_GROUP_ICONS.length];
